/**
 * Build linked-patient payload for ChartMind after CMR share (scanner or cold-provider redeem).
 * Mirrors filtering logic in CMRScanner for consistency.
 *
 * @param {Object} params
 * @param {string} params.patientUserId
 * @param {string|null} [params.patientName]
 * @param {string|null} [params.patientDob]
 * @param {string[]} [params.allowedData]
 * @param {Object|null} [params.cmrData] - Result of fetchPatientCMR
 * @returns {Object} patientInfo for usePatientLinking / sessionStorage
 */
export function buildPatientInfoFromCmrShare({
  patientUserId,
  patientName,
  patientDob,
  allowedData = [],
  cmrData,
}) {
  const allowed = Array.isArray(allowedData) ? allowedData : [];

  const cmrCards = {
    demographics: cmrData?.demographics
      ? {
          firstName: cmrData.demographics.firstName || '',
          lastName: cmrData.demographics.lastName || '',
          dateOfBirth: cmrData.demographics.dateOfBirth || null,
          sex: cmrData.demographics.sex || '',
          phone: cmrData.demographics.phone || '',
          email: cmrData.demographics.email || '',
          address: cmrData.demographics.address || null,
          emergencyContact: cmrData.demographics.emergencyContact || null,
        }
      : {
          firstName: patientName?.split(' ')[0] || '',
          lastName: patientName?.split(' ').slice(1).join(' ') || '',
          dateOfBirth: patientDob || null,
          sex: '',
          phone: '',
          email: '',
          address: null,
          emergencyContact: null,
        },
    medications: allowed.includes('medications')
      ? (cmrData?.medications || []).map((med) => ({
          ...med,
          name: med.name || med.medicationName,
        }))
      : [],
    allergies: allowed.includes('allergies') ? cmrData?.allergies || [] : [],
    pmh: allowed.includes('pmh') && Array.isArray(cmrData?.pmh) ? cmrData.pmh : [],
    psh: allowed.includes('psh') ? cmrData?.psh || [] : [],
    other: allowed.includes('other') ? cmrData?.other || {} : {},
    importedAt: new Date(),
  };

  const displayName = cmrData?.demographics
    ? [cmrData.demographics.firstName, cmrData.demographics.lastName].filter(Boolean).join(' ').trim()
    : patientName || '';

  return {
    patientId: patientUserId,
    name: displayName || patientName || 'Patient',
    dob: cmrData?.demographics?.dateOfBirth || patientDob,
    cmrId: patientUserId,
    fromQueueSelection: false,
    allowedData: allowed,
    cmrCards,
  };
}
